import { MenuItem } from '../models/menu.model';

export const MENU_ITEMS: MenuItem[] = [
  { label: 'Cronograma', icon: 'pi pi-calendar', path: '/cronograma', permission: 'module:schedule' },
  { label: 'Entidades', icon: 'pi pi-users', path: '/entidades', permission: 'module:clients' },
  { label: 'Equipos', icon: 'pi pi-desktop', path: '/equipos', permission: 'module:devices' },
  { label: 'Mantenimientos', icon: 'pi pi-wrench', path: '/mantenimientos', permission: 'module:maintenance' },
  { label: 'Protocolos', icon: 'pi pi-list', path: '/protocolos', permission: 'module:maintenance' },
  { label: 'Fabricantes', icon: 'pi pi-hammer', path: '/fabricantes', permission: 'module:manufacturer' },
  { label: 'Proveedores', icon: 'pi pi-truck', path: '/proveedores', permission: 'module:vendor' },
  { label: 'Usuarios', icon: 'pi pi-users', path: '/usuarios', permission: 'module:users' },
  { label: 'Exportar datos', icon: 'pi pi-download', path: '/exportar', permission: 'takeout:write' },
];
